export default __webpack_public_path__ + "static/media/foto01.d6f03e6c.png";